function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import getResource from "../../services/resources";
import logger from "../../services/logger";

var Media = function Media(_ref) {
  var data = _ref.data,
      className = _ref.className,
      height = _ref.height,
      width = _ref.width,
      defaultUrl = _ref.defaultUrl,
      onFailure = _ref.onFailure,
      propsImg = _objectWithoutProperties(_ref, ["data", "className", "height", "width", "defaultUrl", "onFailure"]);

  // state
  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      url = _useState2[0],
      setUrl = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      onFailureState = _useState4[0],
      setOnFailureState = _useState4[1]; // Si la sauvegarde du fichier à échouer


  var fetchMedia = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id) {
      var response;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return getResource('Media', false).read(id.replace('/media/', ''));

            case 3:
              response = _context.sent;
              _context.t0 = response.mimeType;
              _context.next = _context.t0 === 'application/pdf' ? 7 : _context.t0 === 'video/quicktime' ? 7 : 9;
              break;

            case 7:
              setOnFailureState(true);
              return _context.abrupt("return");

            case 9:
              if (!(response.mimeType.indexOf('video') !== -1)) {
                _context.next = 12;
                break;
              }

              setOnFailureState(true);
              return _context.abrupt("return");

            case 12:
              setOnFailureState(false);
              setUrl(response.path);
              _context.next = 20;
              break;

            case 16:
              _context.prev = 16;
              _context.t1 = _context["catch"](0);
              setOnFailureState(true); // toujours faire ce type de vérif

              if (typeof onFailure === 'function') {
                onFailure(onFailureState);
              }

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 16]]);
    }));

    return function fetchMedia(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  useEffect(function () {
    if (!data) {
      return;
    }

    if (_typeof(data) === 'object') {
      setUrl(data.path);
      return;
    }

    fetchMedia(data);
  }, [data]);

  if (!data || onFailureState) {
    return null;
  }

  try {
    return /*#__PURE__*/React.createElement("div", {
      className: "coreMedia ".concat(className)
    }, /*#__PURE__*/React.createElement("img", _extends({
      src: url,
      height: height,
      width: width,
      alt: ""
    }, propsImg)));
  } catch (e) {
    logger.error('Error Media', '', {
      e: e
    });
    return null;
  }
};

Media.propTypes = {
  data: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]).isRequired,
  className: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
  defaultUrl: PropTypes.any
};
Media.defaultProps = {
  className: '',
  height: '50px',
  width: 'auto',
  defaultUrl: ''
};
export default Media;